import React from 'react'
import { Box, Typography } from '@mui/material'
import PropTypes from 'prop-types'
import HelpRoundedIcon from '@mui/icons-material/HelpRounded'
import { LARGE_RADIUS } from 'utils/constants/Theme'
import TooltipMUI from 'components/styled/TooltipMUI'

const TitledHelpParameter = ({
    image,
    bottomText = '',
    height = 40,
    maxCharactersPerLine = 75,
}) => {
    const normalizedHeight = height.toString()
    return (
        <TooltipMUI
            title={(
                <Box sx={{ display: 'inline-block', '& img': { width: 'auto', height: `${normalizedHeight}vh`, borderRadius: LARGE_RADIUS } }}>
                    <img src={image} alt={bottomText}/>
                    <Typography align='center' sx={{ maxWidth: '100%', whiteSpace: 'pre-line' }}>
                        {bottomText.split('')
                            .reduce((acc, char, i) => {
                                return acc + char + ((i + 1) % maxCharactersPerLine === 0 ? '\n' : '')
                            }, '')
                            .trim()}
                    </Typography>
                </Box>
            )}
            placement='right'
            sx={{ borderRadius: LARGE_RADIUS, padding: 0.5 }}
        >
            <HelpRoundedIcon />
        </TooltipMUI>
    )
}

TitledHelpParameter.propTypes = {
    image: PropTypes.string,
    bottomText: PropTypes.string,
    height: PropTypes.number,
    maxCharactersPerLine: PropTypes.number,
}

export default TitledHelpParameter